
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[...author]",
      function () {
        return require("private-next-pages/author/[...author].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[...author]"])
      });
    }
  